export const DIWALI_2026_PROMOTION_ID = 'DIWALI2026';

/** Diwali runs as a single India / INR tier. */
export type Diwali2026Variant = 'india';

export function getDiwali2026Variant(promotionId: string | null | undefined): Diwali2026Variant | null {
  return promotionId === DIWALI_2026_PROMOTION_ID ? 'india' : null;
}

export function getDiwali2026SlideKey(variant: Diwali2026Variant): string {
  return `diwali-2026-${variant}`;
}

export function resolveDiwali2026Variant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): Diwali2026Variant | null {
  return getDiwali2026Variant(forcedPromotionId) ?? getDiwali2026Variant(promotionId);
}
